import Flex from '@components/Flex/Flex';
import { styled } from '@mui/material';

export const Container = styled(Flex)(({ theme }) => ({
  flex: 1,
  flexDirection: 'column',
  padding: theme.spacing(6, 6, 10, 10),
  border: `1px solid${theme.palette.grey[500]}`,
  borderRadius: theme.spacing(4),
  gap: theme.spacing(4),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(4),
  },
}));
